export class TransformPipeline<CurrentValue> {
  public readonly value: CurrentValue;
  private constructor(initialValue: CurrentValue) {
    this.value = initialValue;
  }
  public static new<CurrentValue>(
    initialValue: CurrentValue,
  ): TransformPipeline<CurrentValue> {
    return new TransformPipeline(initialValue);
  }
  public next<NextValue>(
    function_: (value: CurrentValue) => NextValue,
  ): TransformPipeline<NextValue> {
    const nextValue = function_(this.value);
    return new TransformPipeline(nextValue);
  }
}
